import "./styles.scss";

import { createApp, h } from "vue";
import { createPinia } from "pinia";
import { VueQueryPlugin, QueryClient } from '@tanstack/vue-query';
import AdminDashboard from "./AdminDashboard.vue";
import UsersDashboard from "./features/users/UsersDashboard.vue";
import BookingActionsProvider from "../providers/BookingActionsProvider.vue";
import { createBootstrap } from "bootstrap-vue-next";
import { initUrlConfig } from "../api";

$(document).ready(function () {
    const path = window.location.pathname;
    const isLogs = /\/room-booking\/admin-dashboard\/logs$/.test(path);
    const isUsers = /\/room-booking\/admin-dashboard\/users$/.test(path);
    if (!isLogs && !isUsers) {
        return;
    }

    const container = $("#vue-container");
    if (!container.length) {
        console.error("Admin dashboard container not found");
        return;
    }

    const accountsApiUrl = container.data("accountsApiUrl");

    
    const mountVueApp = (AppComponent, props) => {
        const configForInit = {
            userApiUrl: container.data("userApiUrl"),
            roomBookingApiUrl: container.data("roomBookingApiUrl"),
            adminApiUrl: container.data("adminApiUrl"),
            accountApiUrl: accountsApiUrl,
        };
        initUrlConfig(configForInit);
        const app = createApp({
            render() {
                return h(BookingActionsProvider, null, {
                    default: () => h(AppComponent, props),
                });
            },
        });

        const queryClient = new QueryClient({
            defaultOptions: {
                queries: {
                    staleTime: 1000 * 60 * 5, // 5 minutes
                    gcTime: 1000 * 60 * 30, // 30 minutes
                    retry: 3,
                },
            },
        });
        // Setup TanStack Query
        app.use(VueQueryPlugin, {
            queryClient,
        });
        const pinia = createPinia();
        app.use(pinia);
        app.use(createBootstrap());
        app.mount(container[0]);
    };

    if (isLogs) {
        // Admin dashboard configuration for logs (existing behavior)
        const config = {
            adminApiUrl: container.data("adminApiUrl"),
            roomBookingApiUrl: container.data("roomBookingApiUrl"),
            userApiUrl: container.data("userApiUrl"),
            accountApiUrl: accountsApiUrl,
        };

        // Validate required data
        if (!config.adminApiUrl) {
            console.error("Missing required adminApiUrl for admin dashboard");
            return;
        }

        mountVueApp(AdminDashboard, config);
    }

    if (isUsers) {
        // Mount the real Users dashboard, with accountsApiUrl prop if available
        const props = {
            accountsApiUrl: accountsApiUrl,
        };
        mountVueApp(UsersDashboard, props);
    }
});
